export default __webpack_public_path__ + "static/media/speakup_logo-primary.b3dd70ff.svg";